import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BookingProvider } from "./context/BookingContext";
import "./i18n/i18n";
import { MuiProvider } from "./components/MuiProvider";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
const client = new QueryClient();

root.render(
  <QueryClientProvider client={client}>
    <BookingProvider>
      <BrowserRouter>
        <MuiProvider>
          <App />
        </MuiProvider>
      </BrowserRouter>
    </BookingProvider>
  </QueryClientProvider>
);
